import { types } from "mobx-state-tree";
import ReasonCode from "./ReasonCode";

const ReasonCodeStore = types.model('ReasonCodeStore', {
  reasonCodes: types.optional(types.array(ReasonCode), []),
})
.actions((self) => ({
  setReasonCodes(reasonCodes) {
    let newReasonCodes = [];
    for (let i = 0; i < reasonCodes.length; i++) {
      newReasonCodes.push(ReasonCode.create(reasonCodes[i]));
    }
    self.reasonCodes = [...newReasonCodes];
  },
}));

export default ReasonCodeStore;
